import { render, staticRenderFns } from "./AddSobity.vue?vue&type=template&id=2d23efe0&scoped=true&"
import script from "./AddSobity.vue?vue&type=script&lang=js&"
export * from "./AddSobity.vue?vue&type=script&lang=js&"
import style0 from "./AddSobity.vue?vue&type=style&index=0&id=2d23efe0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d23efe0",
  null
  
)

export default component.exports